module.exports = __webpack_public_path__ + "6f27f412dbfbd743e50dc24f97de7031.svg";